import Cookies from "js-cookie";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { loadingToast } from "src/components_with_stories/toast/toast";
import { AppContext } from "src/context/AppContext";

import useIsLightMode from "./useIsLightMode";

const useNavigateUnauthenticatedUserToSignUpPage = () => {
  const isLightMode = useIsLightMode();
  const navigate = useNavigate();

  const { isAuthenticated, freeTrial } = useContext(AppContext);

  const csrfCookie = Cookies.get("csrftoken");
  const csrfCookieExists = csrfCookie ? csrfCookie.length > 0 : false;

  useEffect(() => {
    // confirmed user has a free trial -> they must be authenticated, so don't redirect
    if (freeTrial) return;

    // user is authenticated and has resources so redirect to the content
    if (isAuthenticated && !freeTrial) {
      loadingToast("You are already a member. Redirecting you to courses.", isLightMode);
      setTimeout(() => {
        navigate("/courses/");
      }, 4000);
      return;
    }

    // it is likely that the user is authenticated, so don't redirect yet
    if (csrfCookieExists) return;

    // user is not authenticated and does not have a free trial, so redirect to sign up page
    if (!isAuthenticated) {
      loadingToast("Join us for free to access this content.", isLightMode);
      setTimeout(() => {
        navigate("/join-us/");
      }, 2000);
      return;
    }
  }, [freeTrial, csrfCookieExists, isAuthenticated]);

  return null;
};

export { useNavigateUnauthenticatedUserToSignUpPage };
